<template>
  <div class="local-ads local-ads--leaderboard">
    <div
      class="local-ads__leaderboard"
      :class="{'local-ads__leaderboard--with-text': showAdsText()}"
    >
      <a
        v-if="getLink() && getMainImageUrl()"
        :href="getLink()"
        :target="props.payload?.target || '_blank'"
      >
        <img
          :src="getMainImageUrl()"
          :srcset="getImageSet()"
          :alt="$t('advertisement.alt')"
        />
      </a>
      <img
        v-else-if="getMainImageUrl()"
        :src="getMainImageUrl()"
        :srcset="getImageSet()"
        :alt="$t('advertisement.alt')"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import type {PropType} from "vue";
import type CncAdPosition from "~/libs/interfaces/CncAdPosition"
import {useArticlesStore} from "~/stores/useArticlesStore"
import {ArticleStoreType} from "~/libs/constants/ArticleStoreType"
import {useAdsApi} from "~/composables/useAdsApi"

const props = defineProps({
  payload: {type: Object as PropType<CncAdPosition>, required: false}
})

const articleStore = useArticlesStore(ArticleStoreType.ADS, props.payload?.cncPosition)

const adsApi = useAdsApi(articleStore, props.payload)

onMounted(() => {
  adsApi.fetch()
})

const getMainImageUrl = adsApi.getMainImageUrl
const getImageSet = adsApi.getImageSet
const showAdsText = adsApi.showAdsText
const getLink = adsApi.getLink
</script>

<style lang="scss">
</style>